import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;

  > img {
    height: 45px;
  }

  ${media.lessThan('sm')`
    flex-direction: column;

    > img {
      margin-top: 16px;
    }
  `};

  ${media.moreThan('sm')`
    justify-content: space-between;

    > img {
      margin-left: 30px;
    }
  `};
`;
